import type { TypographySize } from '@/components/typography/enums/size';
import styled, { css } from 'styled-components';
import type { AnchorHTMLAttributes } from 'react';
import { getLinkStyle } from '../utils/getLinkStyle';
import { getLinkSize } from '../utils/getLinkSize';

export interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  size?: TypographySize.Small | TypographySize.Medium | TypographySize.Large;
  ellipsis?: boolean;
  dataCy?: string;
}

export const StyledExternalLink = styled.a<ExternalLinkProps>`
  ${getLinkStyle}

  :focus-visible {
    color: ${({ theme }) => theme.color.semantic.link.default};
    outline: 2px solid var(--ant-color-primary-border);
    text-decoration: underline;
  }

 ${({ theme, size }) => {
   return css`
    font-size: ${getLinkSize(theme, size)};
  `;
 }}

  ${({ ellipsis }) =>
    ellipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;
